(function (ws) {
    'use strict';

    ws.models.quoteTableTotalUpliftTooltipModel = Backbone.Model.extend({

        /**
         * In order to be consistent with the way we've been using tooltips,
         * this is a fake `fetch` method so emulate an API call.
         */
        fetch: function () {
            return $.Deferred().resolve(this.toJSON());
        }
    });
})(westcon);
